<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-down`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 31.728l16.264-16.264a1 1 0 011.414 0l1.414 1.415a1 1 0 010 1.414L25.414 35.97a2 2 0 01-2.828 0L4.908 18.293a1 1 0 010-1.414l1.414-1.415a1 1 0 011.415 0L24 31.728z"/></svg>
</template>
<script>

export default {
  name: 'IconDown',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
